import { marked } from 'marked';

export class MarkdownParser {
	private _elementBlacklist: string[] = [];

	constructor(elementBlacklist: string[]) {
		this._elementBlacklist = elementBlacklist;
	}

	parse(markdown: string): string {
		const defaultOptions = {
			// deprecated default params
			mangle: false,
			headerIds: false,
		};

		if (this._elementBlacklist.length > 0) {
			// TODO: We still need to add blacklisted elements here
			marked.use({
				tokenizer: {},
				...defaultOptions,
			});
		}

		const parsed = marked(markdown, { async: false, ...defaultOptions });

		return parsed;
	}
}
